<template>
    <div class="tabs-wrapper">
        <div class="tabs" :class="{ 'bg-mode': isBgMode }">
            <div
                class="tab"
                v-for="(item, index) in slotsHeaders"
                :key="index"
                :class="{
                    active: index == activeField,
                    'bg-mode': isBgMode,
                    'is-new': item.isNew,
                }"
                @click="$emit('change-field', index)"
            >
                <div class="tab__inner">
                    <slot name="tab-item" :item="item">
                        {{ item.title }}
                    </slot>
                    <div class="bullet" v-if="item.bullet">
                        {{ item.bullet }}
                    </div>
                </div>
            </div>

            <div class="tab stub" v-if="stub"></div>
        </div>

        <slot :name="currentSlot"></slot>
    </div>
</template>

<script>
export default {
    name: 'Tabs',
    props: {
        activeField: Number,
        slotsHeaders: Array,
        isBgMode: Boolean,
        stub: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        currentSlot() {
            return Object.keys(this.$slots)[this.activeField];
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/rem';

.tabs {
    display: flex;
    cursor: pointer;
    margin-bottom: 1rem;
    border-radius: rem(10) !important;
    font-family: Montserrat, sans-serif;
    overflow: hidden;

    &.bg-mode {
        background: white;
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
        box-shadow: 0 0.3rem 0.5rem rgba(131, 134, 163, 0.12);
    }

    .tab {
        font-size: rem(14);
        font-weight: 500;
        padding: 1rem 0;
        color: #2a2626;
        border-bottom: 1px solid;
        border-bottom-color: rgba(151, 164, 186, 0.3);
        position: relative;
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        justify-content: center;
        text-align: center;

        &.bg-mode {
            background: white;
            border-top-left-radius: 0.25rem;
            border-top-right-radius: 0.25rem;
            padding: 0 0.25rem;
            .tab__inner {
                margin: 0.7rem 0;
                padding: 0.25rem;
            }
        }

        &.active {
            position: relative;
            top: 1px;
            border-bottom: 2px solid #0465ac;
            font-weight: 700;
        }

        &.is-new {
            .tab__inner {
                border-radius: 1rem;
                background: linear-gradient(
                    135deg,
                    rgba(198, 229, 255, 0.8) 0%,
                    rgba(207, 194, 235, 0.6) 52.29%,
                    #e1dfec 100%
                );
            }
        }

        .bullet {
            position: absolute;
            z-index: 10;
            width: 1.2rem;
            height: 1.2rem;
            font-size: 0.6rem;
            color: white;
            background: #ef627d;
            border-radius: 50%;
            top: -0.6rem;
            right: -0.6rem;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 rem(1) rem(1) rgba(155, 161, 166, 0.23626);
        }
    }

    .stub {
        flex-grow: 1;
    }
}
</style>
